import type { Format } from './format'

/** A book keeps its words in its own tree of rows; its identity body stays empty. */
export const book = {
  bodyStorage: 'rows',
  validate: (body: string) => body === '',
  outline: () => [],
  searchText: () => '',
  tools: [],
} as const satisfies Format
